import axios from 'axios';
import { toast } from 'react-hot-toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_ORIGO_BASE_URL || 'http://localhost:3001'
});

// Request interceptor to attach bearer token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("origo_access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }
);

// Response interceptor to handle 401 and 409 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/';
    } else if (error.response?.status === 409) {
      // Show error toast
      toast.error('You are already logged in on another device. Please log out from the other device first.', {
        duration: 6000,
        style: {
          background: '#EF4444',
          color: '#fff',
        },
        id: 'session-conflict', // Unique ID to prevent duplicate toasts
      });
      
      // Clear localStorage
      localStorage.clear();
      
      // Add delay to allow toast to display before redirect
      // Using a longer delay to ensure user sees the message
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    }
    return Promise.reject(error);
  }
);

export default api;
